export default __webpack_public_path__ + "static/media/049-bag.1cfcfe86.svg";